import React, { useState } from "react";
import {Modal } from "antd";
import {
  LinkedinOutlined,
  MailOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

const SocialModal = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <span type="primary" onClick={showModal}>
        {children}
      </span>

      <Modal
        title="Let's chat"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { display: 'none' } }}
        // centered
        // style={{
        //   display: "flex",
        //   flexDirection: "row",
        //   alignItems: "center",
        //   justifyContent: "space-between",
        // }}
      >
        <a
          href="https://api.whatsapp.com/send?phone=919660801827"
          target="_blank"
          rel="noreferrer"
          style={styleLink}
        >
          <WhatsAppOutlined />
        </a>
        <a
          href="https://www.linkedin.com/in/shravanmeena/"
          target="_blank"
          rel="noreferrer"
          style={styleLink}
        >
          <LinkedinOutlined />
        </a>
        <a
          href="mailto:shravanmeena47@gmail.com"
          target="_blank"
          rel="noreferrer"
          style={styleLink}
        >
          <MailOutlined />
        </a>
        <a
          href="tel:+919660801827"
          target="_blank"
          rel="noreferrer"
          style={styleLink}
        >
          <PhoneOutlined />
        </a>
      </Modal>
    </>
  );
};

export default SocialModal;

let styleLink = {
  fontSize: 50,
  marginRight: 30,
};
